import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ForgotPasswordPayload, ForgotPasswordResponse } from '@hcs/types';

import { AuthApi } from '../api';

// Export hook-specific types here rather than in types file
export type UseForgotPasswordOptions = UseMutationOptions<
  ForgotPasswordResponse,
  AxiosError,
  ForgotPasswordPayload,
  void
>;

export const useForgotPassword = (options?: UseForgotPasswordOptions) => {
  return useMutation<
    ForgotPasswordResponse,
    AxiosError,
    ForgotPasswordPayload,
    void
  >(async (forgotPasswordPayload) => {
    return await AuthApi.forgotPassword(forgotPasswordPayload);
  }, options);
};
